import { theBasics, lookAndFeel, advanced, articleLookup } from 'constants/Settings'

export const buildHeaderCopy = page => {
  let title;
  let secondaryText;
  
  switch(page) {
    case theBasics:
      title='Basic Customization'
      secondaryText='Customize your title, description and domain settings.'
      break;
    
    case lookAndFeel:
      title='Look and Feel of Drift Help'
      secondaryText='Customize your background color, logo and favicon.'
      break;
    
    case advanced:
      title='Advanced Drift Help Settings'
      secondaryText='Measure your traffic and visibility on search engines.'
      break;
      
    case articleLookup:
      title='Suggest Knowledge Base Articles'
      secondaryText='Driftbot suggests articles from your knowledge base in conversations'
      break;
      
    default:
      title=''
      secondaryText=''
  }
  
  return { title, secondaryText }
}

